module.exports = __webpack_public_path__ + "69ba8d25fedb16c438f6bf559cb126f3.png";